import axios from '@/services/httpClient';
import { useAuthStore } from '@/stores/authStore';

export const registerIntegration = async (payload, retryAttempt = false) => {
    const authStore = useAuthStore();

    try {
        const params = new URLSearchParams({
            user_uuid: payload.user_uuid,
        });

        if (payload.description) {
            params.append('description', payload.description);
        }

        const response = await axios.post(`/nora_superadmin/create-integration-key?${params.toString()}`, {}, {
            headers: {
                Authorization: `Bearer ${authStore.accessToken}`,
            },
        });

        return response.data;
    } catch (error) {
        if (error.response?.status === 401 && !retryAttempt) {
            // Token might be expired, attempt to refresh
            await authStore.refreshAccessToken();
            return registerIntegration(payload, true); // Retry after refreshing
        }
        throw error;
    }
}

export const getIntegration = async (user_uuid, organization_uuid, retryAttempt = false) => {
    const authStore = useAuthStore();

    try {
        const response = await axios.get('/nora_superadmin/integration-keys',{
            headers: {
                Authorization: `Bearer ${authStore.accessToken}`,
            },
            params: {
                organization_uuid,
                user_uuid, 
            }
        });

        return response.data;
    } catch (error) {
        if (error.response?.status === 401 && !retryAttempt) {
            // Token might be expired, attempt to refresh
            await authStore.refreshAccessToken();
            return getIntegration(user_uuid, organization_uuid, true); // Retry after refreshing
        }
        throw error;
    }
}

export const getIntegrationKeys = async (params = {}, retryAttempt = false) => {
    const authStore = useAuthStore();

    try {
        const response = await axios.get('/nora_superadmin/integration-keys',{
            headers: {
                Authorization: `Bearer ${authStore.accessToken}`,
            },
            params,
        });

        return response.data;
    } catch (error) {
        if (error.response?.status === 401 && !retryAttempt) {
            // Token might be expired, attempt to refresh
            await authStore.refreshAccessToken();
            return getIntegrationKeys(params, true); // Retry after refreshing
        }
        throw error;
    }
};

export const getAllIntegration = async (retryAttempt = false) => {
    return getIntegrationKeys({}, retryAttempt);
};

export const deactivateIntegration = async (uuid, retryAttempt = false) => {
    const authStore = useAuthStore();
  
    try {
      const response = await axios.patch(`${await authStore.get_url()}/deactivate-integration-key/${uuid}`, {} ,{
        headers: {
          Authorization: `Bearer ${authStore.accessToken}`,
        },
      });
  
      return response.data;
    } catch (error) {
        if (error.response?.status === 401 && !retryAttempt) {
            // Token might be expired, attempt to refresh
            await authStore.refreshAccessToken();
            return deactivateIntegration(uuid, true); // Retry after refreshing
        }
        throw error;
    }
};
